module.exports = __webpack_public_path__ + "static/media/icon_arrow_R_list.33af9f4c.svg";